module.exports = __webpack_public_path__ + "static_portal/img/11.315c0b62.jpg";